import React, { Fragment, useState } from "react";
import { TabList } from "cstar-react-primitives";
import PropTypes from "prop-types";

import SingleSignOn from "./SingleSignOn";
import { useFormatMessage } from "../../../intl/intlHooks";
import { orderSummarySSOCheckout } from "../orderSummaryMessages";
import { cashbotName } from "../../core";

const SSOTabs = ({ children }) => {
    const formatMessage = useFormatMessage();
    const [isGuest, setIsGuest] = useState(undefined);

    return (
        <Fragment>
            <TabList
                legend={formatMessage(orderSummarySSOCheckout.checkoutType)}
                name="login-options"
                cssClass="checkout-tabs"
                cashbotName={cashbotName}
                fullWidth
                tabItems={[
                    {
                        label: formatMessage(orderSummarySSOCheckout.loginTabLabel),
                        value: "isSSO"
                    },

                    {
                        label: formatMessage(orderSummarySSOCheckout.guestTabLabel),
                        value: "isGuest"
                    }
                ]}
                handleSelect={value => value === 'isSSO' ? setIsGuest(false) : setIsGuest(true)}
            />
            {isGuest ? children : <SingleSignOn />}
        </Fragment>
    );
};

SSOTabs.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default SSOTabs;
